import { ElementRef } from '@angular/core';
import { FrameContext } from '@farris/devkit';

export class ComponentRef {
  constructor(protected frameContext: FrameContext, protected elementRef: ElementRef) { }
  public addComponent(componentRef: any) {
    const id = this.elementRef && this.elementRef.nativeElement && this.elementRef.nativeElement.id;
    if (this.frameContext && id && componentRef) {
      this.frameContext.componentRefManager.add(id, componentRef);
    }
  }
  public tryAddComponent(componentRef: any, componentId: string = null) {
    const id = componentId || this.elementRef && this.elementRef.nativeElement && this.elementRef.nativeElement.id;
    if (this.frameContext && id && componentRef && !this.frameContext.componentRefManager.has(id)) {
      this.frameContext.componentRefManager.add(id, componentRef);
    }
  }
}
